





















import Vue from 'vue'
import Box from './box.vue'

export default Vue.extend({
  data () {
    return {
    }
  },

  components: {
    Box
  },

  props: {
    detail: {
      type: Object
    },
    isSelf: {
      type: Boolean
    }
  },

  methods: {
    handleOpt (type: string) {
      this.$emit('opt', type)
    }
  }
})
